/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const e={unspecified:0,codedValue:1,range:2};export{e as EsriDomainType};
